/**
 * Mobil uygulama (SoftinyaApp) bağlantı ayarları.
 *
 * Mobil uygulamada karşılığı: softinya-mobil-app/lib/link-domains.js (APP_SCHEME)
 * ve app.config.ts (scheme / package / bundleIdentifier).
 *
 * Universal Link (iOS) ve App Link (Android) yalnızca uygulamanın imajına
 * gömülü domainlerde çalışır. Kayıtlı olmayan domainlerde ve adres çubuğuna
 * elle yazılan adreslerde `scheme` üzerinden açılır (OpenInAppBanner.vue).
 */
export const AppLinks = {
  scheme: "softinyalms",
  android: {
    package: "com.softinya.lms",
    storeUrl:
      "https://play.google.com/store/apps/details?id=com.softinya.lms&hl=tr",
  },
  ios: {
    appId: "6759368902",
    storeUrl: "https://apps.apple.com/tr/app/softinya-app/id6759368902",
  },
};

/** Cihazın mobil platformu: "ios" | "android" | null (masaüstü). */
export function detectMobilePlatform() {
  const ua = window.navigator.userAgent || "";

  if (/Android/i.test(ua)) {
    return "android";
  }

  // iPadOS 13+ masaüstü UA bildirir; dokunma desteğiyle ayrışır.
  const isIosLike =
    /iPhone|iPad|iPod/i.test(ua) ||
    (/Macintosh/i.test(ua) && window.navigator.maxTouchPoints > 1);

  return isIosLike ? "ios" : null;
}

/** Mobil uygulamada hedef sayfayı açan derin bağlantı. */
export function buildAppDeepLink(url) {
  return `${AppLinks.scheme}://open?url=${encodeURIComponent(url)}`;
}

/**
 * Android'de uygulamayı açar, kurulu değilse Play Store'a düşer.
 * Chrome yalnızca kullanıcı etkileşimiyle çalıştırır.
 *
 * Chrome intent:// adresini Intent.parseUri ile BİR KEZ decode edip uygulamaya
 * verir; tek kodlamada hedefteki `#` ve `&` dış URL'e karışır ve sayfa kaybolur
 * (softinyalms://open?url=http://host/#/x → fragment dışarıda kalır). Bu yüzden
 * hedef çift kodlanır; uygulamaya tek kodlanmış hali ulaşır.
 */
export function buildAndroidIntentLink(url) {
  const fallback = encodeURIComponent(AppLinks.android.storeUrl);

  return (
    `intent://open?url=${encodeURIComponent(encodeURIComponent(url))}` +
    `#Intent;scheme=${AppLinks.scheme};package=${AppLinks.android.package};` +
    `S.browser_fallback_url=${fallback};end`
  );
}
